import { IRuleMySuffix } from 'src/app/shared/model//rule-my-suffix.model';
import { ISanctionedGroupMySuffix } from 'src/app/shared/model//sanctioned-group-my-suffix.model';
import { IUnderwriterMySuffix } from 'src/app/shared/model//underwriter-my-suffix.model';
import { IInsuranceCompanyMySuffix } from 'src/app/shared/model//insurance-company-my-suffix.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface ICountryMySuffix {
    id?: number;
    name?: string;
    currency?: string;
    isoTwo?: string;
    code?: number;
    activeStatus?: ActiveStatus;
    fromCountryRules?: IRuleMySuffix[];
    toCountryRules?: IRuleMySuffix[];
    sanctionedGroups?: ISanctionedGroupMySuffix[];
    underwriterLanCountries?: IUnderwriterMySuffix[];
    underwriterAcCountries?: IUnderwriterMySuffix[];
    icLanCountries?: IInsuranceCompanyMySuffix[];
    icAcCountries?: IInsuranceCompanyMySuffix[];
}

export class CountryMySuffix implements ICountryMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public currency?: string,
        public isoTwo?: string,
        public code?: number,
        public activeStatus?: ActiveStatus,
        public fromCountryRules?: IRuleMySuffix[],
        public toCountryRules?: IRuleMySuffix[],
        public sanctionedGroups?: ISanctionedGroupMySuffix[],
        public underwriterLanCountries?: IUnderwriterMySuffix[],
        public underwriterAcCountries?: IUnderwriterMySuffix[],
        public icLanCountries?: IInsuranceCompanyMySuffix[],
        public icAcCountries?: IInsuranceCompanyMySuffix[]
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
    }
}


export class CountryTreeView{
    constructor(
        public text?: string,
        public value?: number,
        public children?:CountryTreeView[]
    ) {}
}